export default "__VITE_ASSET__mdqiGQUX__"